import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '../lib/errors';

/**
 * A screen that throws while rendering shows this instead of going blank, and
 * the error is reported. Moving to another screen (`resetKey`) tries again.
 */
export class ErrorBoundary extends Component<{ resetKey: string; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, 'render', info.componentStack ?? '');
  }

  componentDidUpdate(prev: { resetKey: string }) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="signin" style={{ justifyContent: 'center' }}>
        <div className="mark" style={{ fontSize: 30 }}>Something went wrong</div>
        <p className="tag">
          This screen hit a problem and it's been reported. Your trips and expenses are safe —
          reloading usually fixes it.
        </p>
        <button className="btn" style={{ marginTop: 24 }} onClick={() => location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
